import React from 'react';
import { ArrowLink } from 'inside-out/components/shared/arrowLink';
import { Cards } from 'inside-out/components/shared/cards';
import { ColouredCard } from 'inside-out/components/shared/cards/colouredCard';
import {
	getInvolvedStyle,
	getInvolvedWrapperStyle,
	getInvolvedInnerStyle,
	ctaStyle,
	titleStyle,
} from './styles';

import { tabletPortraitMaxWidthBreakpoint, pink, aqua } from 'inside-out/global-styles';

export const GetInvolved = () => (
	<section className={getInvolvedStyle}>
		<div className={getInvolvedInnerStyle}>
			<div className={getInvolvedWrapperStyle}>
				<h1 className={titleStyle}>Get Involved</h1>
				<Cards
					columns={2}
					scrollable={false}
					columnsAt={{
						[`max-width: ${tabletPortraitMaxWidthBreakpoint}`]: 1,
					}}
				>
					<ColouredCard
						to="/get-involved/make-a-donation"
						background={pink}
						title="Donate"
						body="Donate now to help people and their families living with an eating disorder."
						animateTitleLetter="o"
						arrow={true}
					/>
					<ColouredCard
						to="/get-involved/hold-a-fundraiser"
						background={aqua}
						title="Hold a Fundraiser"
						body="Hold a fundraiser to contribute to research, education and treatment."
						animateTitleLetter="e"
						arrow={true}
					/>
				</Cards>
			</div>
			<p className={ctaStyle}>
				<ArrowLink to="/get-involved">More ways to get involved</ArrowLink>
			</p>
		</div>
	</section>
);



// WEBPACK FOOTER //
// ./src/components/shared/getInvolved/component.js